export default __webpack_public_path__ + "static/media/DHQ-logo-allwhite-cropped.ffd24614.png";